import { render, staticRenderFns } from "./self-settle.vue?vue&type=template&id=0c147921&scoped=true"
import script from "./self-settle.vue?vue&type=script&lang=js"
export * from "./self-settle.vue?vue&type=script&lang=js"
import style0 from "./self-settle.vue?vue&type=style&index=0&id=0c147921&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c147921",
  null
  
)

export default component.exports